import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { OMEGA } from "../../../../constants";


export default function OmegaAddOnCard() {
  

return (

    <CardImageMarkers 
    
        image={OMEGA}
        title="OMEGA HEALTH LIFESTYLE"
        subtitle="Optimizing essential fatty acids to support brain function, cognitive performance, and healthy inflammatory balance for long-term wellness"
        markersTitle="€ 99,- incl. VAT"
        markers="Omega-3 Fatty Acids, Omega-6 Fatty Acids, Monounsaturated Fatty Acids (MUFA), Saturated Fatty Acids (SFA), Polyunsaturated Fatty Acids (PUFA), Fatty Acid Ratios & Indices (Omega-6/Omega-3 ratio, SFA/MUFA ratio, AA/DGLA, AA/EPA)"

    />


)
}